var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('div',[_c('b-navbar',{staticClass:"unguprimary",attrs:{"variant":"faded","type":"light"}},[_c('b-navbar-brand',{staticClass:"mx-2 text-light",attrs:{"href":"/home"}},[_vm._v("HOSPITAL MANAGEMENT SYSTEM")])],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }